import { useState, useCallback } from 'react';
import { HomeIcon } from 'src/components/ui-icons/menu';
import TGButton from 'src/components/ui/TGButton';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { TooltipItem } from 'src/utils/Tooltip';
// import { DownloadIcon } from 'src/components/ui-icons/upload';
import { DrawerComponent } from 'src/components/DialogComponent';
import PrescriptionForm from '../prescription-form/prescription-form';
import LicenseForm from '../license-form/license-form';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUser } from 'src/modules/users/selector';
import { useAppSelector } from 'src/hooks/redux';
import { License, Prescription } from '../../types/data';
import ExportDataGos from '../exportExcel/ExportDataGos';

type PageHeadProps = {
  isLicenses?: boolean;
  isExportLic?: boolean;
  data: Prescription[] | License[];
};

function PageHead({ isLicenses, data, isExportLic }: PageHeadProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const isUserLoaded = Boolean(currentUser?.displayName && currentUser?.email);

  const navigate = useNavigate();

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleClickLicenses = () => {
    if (isLicenses) return;
    navigate('/dashboard/4/licenses');
  };

  const handleClickPrescription = () => {
    if (!isLicenses) return;
    navigate('/dashboard/4/');
  };

  return (
    <>
      <div className='flex items-center text-gray-600 mb-5 gap-2 py-4'>
        <HomeIcon />
        <span>Главная</span>
        <span className='mx-2'>→</span>
        <span className='text-base mr-auto'>
          <span className='mr-1' style={{ color: `${isLicenses ? '#637381' : '#012169'}`, cursor: `${isLicenses ? 'pointer' : 'default'}` }} onClick={handleClickPrescription}>
            Предписания
          </span>
          |
          <span className='ml-1' style={{ color: `${isLicenses ? '#012169' : '#637381'}`, cursor: `${isLicenses ? 'default' : 'pointer'}` }} onClick={handleClickLicenses}>
            Лицензии и разрешения
          </span>
        </span>

        <TooltipItem position='left' tooltipsText={'Экспорт в Excel'}>
          <ExportDataGos data={data} isExportLic={isExportLic} />
        </TooltipItem>

        <TGButton icon={<PlusCircleIcon width='20' height='20' />} onClick={() => setIsOpen(true)} color='bluedark' disabled={!isUserLoaded}>
          {isLicenses ? 'Создать документ' : 'Создать предписание'}
        </TGButton>
      </div>

      {isLicenses ? (
        <DrawerComponent open={isOpen} zIndex={50} toggleDrawer={closeModal}>
          <LicenseForm toggleDoing={closeModal} isNewForm={true} />
        </DrawerComponent>
      ) : (
        <DrawerComponent open={isOpen} zIndex={50} toggleDrawer={closeModal}>
          <PrescriptionForm toggleDoing={closeModal} isNewForm={true} />
        </DrawerComponent>
      )}
    </>
  );
}

export default PageHead;
